import Vue from 'vue';
import { MutationTree } from 'vuex';
import { GroupModel } from '@descomplica/dex-models';

import { GroupState } from './state';

const mutations: MutationTree<GroupState> = {
  SET_GROUPS(state, groups: GroupModel[]) {
    if (!groups) return;

    groups.forEach((group) =>
      Vue.set(state.groups, group.id.toString(), {
        ...state.groups[group.id],
        ...group,
      }),
    );
  },
};

export default mutations;
